var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmmIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_141",
    "data-name": "Group 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164.447,
    height: 101.668,
    viewBox: "0 0 164.447 101.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 164.447,
    height: 101.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.904,
    gradientTransform: "matrix(0.441, 0, 0, -0.598, -0.08, 2.195)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b7dce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    stopColor: "#6b78ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#6b6ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b62ce"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M149.821,90H8.5C3.807,90,0,94.307,0,99.62V169.58c0,5.313,3.807,9.621,8.5,9.621H149.821c4.7,0,8.5-4.307,8.5-9.621V99.62c0-5.313-3.807-9.62-8.5-9.62",
    transform: "translate(0 -77.532)",
    fill: "#293d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M199.821,0H58.5C53.807,0,50,4.307,50,9.62V79.58c0,5.313,3.807,9.62,8.5,9.62H199.821c4.7,0,8.5-4.307,8.5-9.62V9.62c0-5.313-3.807-9.62-8.5-9.62",
    transform: "translate(-43.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M153.5,87.642v64.641H283.733v.554H153.009v-65.2Z",
    transform: "translate(-134.273 -75.501)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 64.918,
    transform: "translate(149.46 12.141)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 64.918,
    transform: "translate(116.84 12.141)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 64.918,
    transform: "translate(84.22 12.141)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 64.918,
    transform: "translate(51.601 12.141)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 130.479,
    transform: "translate(18.981 77.059)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 130.479,
    transform: "translate(18.981 55.42)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 130.479,
    transform: "translate(18.981 33.78)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 130.479,
    transform: "translate(18.981 12.141)",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M155.009,221.673c23.557-20.592,40.27-28.1,59.346-22.861s25.8,12.914,39.892,9.075c16.275-4.433,20.7-24.432,31.242-29.842",
    transform: "translate(-136.028 -153.38)",
    fill: "none",
    stroke: "#3b51eb",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M155.009,276.847c5.985,8.022,17.016,12.041,27.19,7.679s32.882-21.989,52.139-20.767,22.557,9.233,33.533,12.295,13.72-16.169,17.617-18.769",
    transform: "translate(-136.028 -221.643)",
    fill: "none",
    stroke: "#ebcc51",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M155.009,287.392c13.383,10.08,28.28,14.269,50.08,14.443s34.154-14.511,50.323-18.393,20.366.418,30.076.942",
    transform: "translate(-136.028 -242.791)",
    fill: "none",
    stroke: "#ff791f",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmmIcon03);
export default __webpack_public_path__ + "static/media/DMM_icon03.885482775fdebaabc225536ed8e6036f.svg";
export { ForwardRef as ReactComponent };